<template>
  <div class="DbEmails">
    <h4>Templates</h4>

    <!-- Baumstruktur für Ordner & E-Mails -->
    <TreeWrapper @moveItem="moveItem" @selectItem="showMetaInfo" @loadEmail="loadEmailDetails" />

    <!-- Meta-Infos zu einer E-Mail -->
    <div v-if="selectedEmailId" class="email-meta">
      <p><strong>Erstellt am:</strong> {{ selectedEmailData.created_at }}</p>
      <p><strong>Zuletzt aktualisiert:</strong> {{ selectedEmailData.updated_at }}</p>
      <button @click="showModal = true"><span class="material-symbols-outlined">delete</span> Löschen</button>
    </div>

    <!-- Bestätigungsmodal für das Löschen -->
    <ConfirmationModal 
      v-if="showModal" 
      @confirm="deleteSelectedMail(selectedEmailId)" 
      @close="showModal = false"
      MainText="Mail endgültig löschen?"
      Header="Löschen"
    />
  </div>
</template>

<script>
import { ref} from 'vue';
import { deleteMail } from '@/utils/db/deleteMail';
import ConfirmationModal from './Feedback/ConfirmationModal.vue';
import TreeWrapper from './DbTree/DbTreeWrapper.vue';

export default {
  name: 'EmailList',
  components: { ConfirmationModal, TreeWrapper },
  setup(_, { emit }) {
    const showModal = ref(false);
    const selectedEmailId = ref(null);
    const selectedEmailData = ref(null);

    // API: E-Mail löschen
    const deleteSelectedMail = async (id) => {
      try {
        await deleteMail(id);
        selectedEmailId.value = null;
        selectedEmailData.value = null;
        emit('fetchEmails'); // Aktualisiert die Liste nach dem Löschen
      } catch (error) {
        console.error('Fehler beim Löschen der E-Mail:', error);
      }
    };

    // Einzelklick: Meta-Infos anzeigen
    const showMetaInfo = (emailId) => {
      console.log('Meta-Infos für:', emailId);
      selectedEmailId.value = emailId;
    };

    // Doppelklick: E-Mail öffnen
    const loadEmailDetails = async (emailId) => {
      console.log('Lade Mail-Details für ID:', emailId);
      try {
        await emit('load-email', emailId);
      } catch (error) {
        console.error('Fehler beim Laden der Mail-Details:', error);
      }
    };

    // Drag & Drop: Element verschieben
    const moveItem = async (item, newParent) => {
      console.log(`Verschiebe ${item.key} nach ${newParent?.key || 'Root'}`);
      // Die Logik für API-Update liegt in `TreeWrapper`
    };

    return {
      showModal,
      selectedEmailId,
      selectedEmailData,
      deleteSelectedMail,
      showMetaInfo,
      loadEmailDetails,
      moveItem
    };
  }
};
</script>

<style scoped>
.DbEmails {
  padding-top: 5px;
  position: relative;
  max-width: 100%;
}

h4 {
  text-align: left;
}


.email-meta {
  font-size: 0.9em;
  color: #666;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 5px;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ccc;
  border-color: transparent;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background: darkgray;
}
</style>



  